import { useNavigate } from 'react-router-dom';
import useApartmentFilterNotification, {
  ApartmentFilterNotification,
} from '../../../api/hooks/use-apartment-filter-notification';
import { useState } from 'react';
import { NotificationFlowPaths } from '../../../routes';
import { deleteFilterNotificationStatus } from '../../../api';
import ErrorMessage from '../../../components/error-message';
import styles from '../../choose-apartment-complex/styles.module.scss';
import Loader from '../../../components/loader';
import DeleteModal from '../../../components/delete-modal';
import { Virtuoso } from 'react-virtuoso';
import { ITEMS_PER_PAGE } from '../../../lib/constants';
import ApartmentFilterListItem from '../../../components/apartment-filter-list-item';
import IconButton from '../../../components/icon-button';
import bellFilled from '../../../assets/images/bell-filled.svg';
import LoadMoreVirtualListFooter from '../../../components/load-more-virtual-list-footer';
import NotFound from '../../../components/not-found';

interface NotificationFilterProps {
  isSecondaryMode?: boolean;
}

export const NotificationSecondaryFilter: React.FC<NotificationFilterProps> = ({
  isSecondaryMode,
}) => {
  const navigate = useNavigate();
  const {
    error,
    total,
    mutate,
    data: filterNotification,
    setSize,
    isLoadingMore,
    isInitialLoading,
  } = useApartmentFilterNotification(true);

  const [isShowDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [filterId, setFilterId] = useState<number | null>(null);

  const handleRedirectFilterItem = (filterGroup: ApartmentFilterNotification) =>
    navigate(NotificationFlowPaths.notificationFilterItem, { state: { id: filterGroup.id } });

  const handleDeleteFilterNotification = async (filterGroupId: number) => {
    await deleteFilterNotificationStatus(filterGroupId, mutate);
  };

  return error && filterNotification?.length === 0 ? (
    <ErrorMessage className={styles.margined} message={error} />
  ) : isInitialLoading ? (
    <Loader className={styles.margined} />
  ) : filterNotification.length > 0 ? (
    <>
      {isShowDeleteModal && (
        <DeleteModal
          isOpen={true}
          onDelete={() => !!filterId && handleDeleteFilterNotification(filterId)}
          onClose={() => setShowDeleteModal(false)}
        />
      )}
      <Virtuoso
        style={{ height: `100vh` }}
        context={{
          total,
          loading: isLoadingMore,
          per: ITEMS_PER_PAGE,
          loadedNum: filterNotification.length,
          loadMore: () => setSize((s) => s + 1),
        }}
        data={filterNotification}
        itemContent={(index, filterGroup) => (
          <ApartmentFilterListItem
            onClick={() => handleRedirectFilterItem(filterGroup)}
            filterGroup={filterGroup}
            leftIcon={
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDeleteModal(true);
                  setFilterId(filterGroup?.id);
                }}
                icon={bellFilled}
              />
            }
          />
        )}
        components={{ Footer: LoadMoreVirtualListFooter }}
      />
    </>
  ) : (
    <NotFound />
  );
};
